export const inDollars = cents => (cents > 0 ? cents / 100 : 0);
